import Icon from '../../ui-kit/components/atoms/Icon'
import UserItem from '../../ui-kit/components/molecules/UserItem'
import {CALENDAR_ICON} from '../../ui-kit/helpers/icons/calendar'

const AnniversarySection = () => {
  return (
    <section className="aside-section n-container">
      <h2 className="title title-base">
        <Icon size="20px" svg={CALENDAR_ICON} /> Aniversarios
      </h2>
      <div className="list">
        <UserItem />
        <UserItem />
        <UserItem />
        <UserItem />
        <UserItem />
      </div>
    </section>
  )
}

export default AnniversarySection
